import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerBySubRoute } from '../../../interfaces/busines-partner-by-sub-route.interface';

@Component({
  selector: 'app-bulk-gps-partner-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-0.5 py-0.5 leading-tight">
      <span class="text-xs font-bold">{{ code() }}</span>
      <span class="truncate text-xs text-gray-600 dark:text-gray-400">{{ name() }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkGpsPartnerCellRendererComponent {
  readonly params = input.required<CellRendererParams<BusinessPartnerBySubRoute>>();

  readonly code = computed(() => this.params().data?.externalKeys?.code ?? '-');
  readonly name = computed(() => this.params().data?.name ?? '-');
}
